import React from "react";
// import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import CardBio from "@qlik/qlik/src/components/CardContainer/Bio";
import AuthorBlogs from "@qlik/qlik/src/components/CardContainer/Listing/Blog";

/**
 * Template component for Author inner page.
 * It displays the content type and rendering of the passed data.
 *
 * @param {Object} data - The data to be displayed.
 * @returns {JSX.Element} A section element containing the content type and rendering of the data.
 */
const AuthorSingleEntry = ({ data }) => {
    const { firstName, lastName, subtitle, avatar, authorBio } = data || {};
    const authorName = `${firstName} ${lastName}`;
    const authorData = {
        cardItem: { title: `${firstName} ${lastName}`, subtitle, media: [avatar], body: authorBio },
    };
    const selectedFilters = { author: authorName };
    return (
        <>
            <CardBio className="pb-0 lg:pb-5" data={authorData} />
            <AuthorBlogs className="pt-5 lg:pb-7.5" data={{ selectedFilters }} />
        </>
    );
};

export default AuthorSingleEntry;
